import React from 'react';
import { hydrate } from 'react-dom';
import { Provider } from 'react-redux';
import thunkMiddleware from 'redux-thunk';
import { createStore, applyMiddleware } from 'redux';
// TODO: check is it okay to list it in dependencies
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import reviewsReducer, { ReviewAppState } from './redux/reducers';
import App from './components/App';
import ScrollToTop from './components/ScrollToTop';
import Review from '../server/domain/Review';

declare global {
  interface Window {
    preloadedState: ReviewAppState;
  }
}

let { preloadedState } = window;
delete window.preloadedState;

// snippet to have native Map show up in redux-devtools
// TODO: only needed in dev environment
(Map.prototype as any).toJSON = function () {
  return JSON.parse(JSON.stringify([...this]));
};

const chunkInefficient = (arr: any[], chunkSize: number) =>
  [].concat(
    ...arr.map(function (elem, i) {
      return i % chunkSize ? [] : [arr.slice(i, i + chunkSize)];
    })
  );

const filteredReviewsChunked = chunkInefficient(preloadedState.reviews, preloadedState.limit);
const reviewPages: Map<number, Review[]> = new Map<number, Review[]>();
reviewPages.set(0, []);

filteredReviewsChunked.forEach((chunk: Review[], index: number) => {
  reviewPages.set(index + Number(preloadedState.page), chunk);
});

// TODO: since maps cant be JSON-ified, reviewsMap needs to be generated on the client
preloadedState = {
  ...preloadedState,
  reviewsMap: reviewPages
};

const middlewares = [thunkMiddleware];
const middlewareEnhancer = applyMiddleware(...middlewares);

const store = createStore(reviewsReducer, preloadedState, composeWithDevTools(middlewareEnhancer));

hydrate(
  <Provider store={store}>
    <ScrollToTop>
      <App />
    </ScrollToTop>
  </Provider>,
  document.getElementById('root')
);
